// tslint:disable: completed-docs
import {
    APP,
    CONTAINER_MAIN,
} from 'Constant';
import { ApiCredentials } from '@vfde-fe/utils';

// Actions
export const GET_DEVICE = `${APP}/${CONTAINER_MAIN}/GET_DEVICE` as const;
export const SHOW_LOADING = `${APP}/${CONTAINER_MAIN}/SHOW_LOADING` as const;
export const CREATE_INITIAL_STATE = `${APP}/${CONTAINER_MAIN}/CREATE_INITIAL_STATE` as const;
export const TRIGGER_GIGAKOMBI_OVERLAY = `${APP}/${CONTAINER_MAIN}/TRIGGER_GIGAKOMBI_OVERLAY` as const;
export const GET_DEVICE_SUCCESS = `${APP}/${CONTAINER_MAIN}/GET_DEVICE_SUCCESS` as const;
export const GET_DEVICE_FAILED = `${APP}/${CONTAINER_MAIN}/GET_DEVICE_FAILED` as const;
export const TOGGLE_HARDWARE_ONLY = `${APP}/${CONTAINER_MAIN}/TOGGLE_HARDWARE_ONLY` as const;
export const GO_TO_BASKET = `${APP}/${CONTAINER_MAIN}/GO_TO_BASKET` as const;
export const SET_DEFAULT_STATE = `${APP}/${CONTAINER_MAIN}/SET_DEFAULT_STATE` as const;
export const TOGGLE_INSURANCE = `${APP}/${CONTAINER_MAIN}/TOGGLE_INSURANCE` as const;
export const TOGGLE_TRADE_IN = `${APP}/${CONTAINER_MAIN}/TOGGLE_TRADE_IN` as const;
export const TRIGGER_TRADE_IN_TRACKING = `${APP}/${CONTAINER_MAIN}/TRIGGER_TRADE_IN_TRACKING` as const;
export const HANDLE_PAGESHOW = `${APP}/${CONTAINER_MAIN}/HANDLE_PAGESHOW` as const;

export const SAILS_READY_EVENT = 'SAILS:ready';

// API
export const API_DEV_URL = 'https://jarvis-hardware-details-k8s-wf-de-develop.wf-de.vodafone.com/api/v6/hardwareDetails';
export const API_DEV_KEY = 'test';
export const API_KEY = 'emz69zyRgQHkzFXmN6FG1QDchFqVboDD';
export const API_URL = 'https://eweb8.vfd2-testnet.de/api/jarvis/v6/hardwareDetails';
export const API_CREDENTIALS: ApiCredentials = {
    prod: {
        url: API_URL,
        key: API_KEY,
    },
    dev: {
        url: API_DEV_URL,
        key: API_DEV_KEY,
    },
};

// Gigakombi (todo: move to constants)
export const GIGAKOMBI_URL_PARAM = 'gigakombi';
export const GIGAKOMBI_TOKEN_PARAM = 'token';

// Miscellaneous
export const HEADLINE_DELIVERY_SCOPE = 'Lieferumfang';
export const HARDWARE_ONLY_SWITCH = 'hardware-details__hardware-only-switch';
export const SAILS_PARAM_HARDWAREONLY = 'hardwareOnly';
export const OFFER_PRICE_CONTAINER = 'hardware-details__offer-price';
export const HORIZONTAL_LIST_CONTAINER = 'horizontal-list-container';
export const HEADLINE_CONTAINER = 'hardware-details__headline';
export const SUBLINE_CONTAINER = 'hardware-details__subline';
export const UNORDERED_HORIZONTAL_LIST_BASE_CLASSNAME = 'brix-unordered-horizontal-list';
export const TECHNICAL_DETAILS_ACCORDION = 'hardware-details__accordion';
export const XSELL_PP_VOUCHER_COOKIE_KEY = 'XSELLGMXS7EURO';

// Insurance
export const INSURANCE_FEATURE_TILE_CONTAINER = 'hardware-details__insurance-feature-tile';
export const TRACKING_SWITCH_OPTIONS = 'switch options';
export const TRACKING_INFORMATION = 'information';

// Trade in
export const TRADE_IN_PROMO_TILE_CONTAINER = 'hardware-details__trade-in';
